import React from 'react';

const formatCurrency = (val) => {
  if (val == null || isNaN(val)) return '$0';
  return `$${Number(val).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
};

const RentToOwnBusinessYearlyTable = ({ yearlyData }) => {
  if (!yearlyData || yearlyData.length === 0) {
    return <div className="text-center text-gray-500">No data available.</div>;
  }

  return (
    <div className="overflow-x-auto mt-6">
      <table className="min-w-full bg-white border border-gray-300 rounded-md shadow-sm text-xs">
        <thead className="bg-gray-100 text-left font-semibold">
          <tr>
            <th className="px-4 py-2 border">Year</th>
            <th className="px-4 py-2 border">Asset Value</th>
            <th className="px-4 py-2 border">Investor Equity</th>
            <th className="px-4 py-2 border">Entrepreneur Equity</th>
            <th className="px-4 py-2 border">Rent Income</th>
            <th className="px-4 py-2 border">Net Cashflow</th>
            <th className="px-4 py-2 border">Equity Bought</th>
            <th className="px-4 py-2 border">Reinvested Capital</th>
            <th className="px-4 py-2 border">Gold Value</th>
            <th className="px-4 py-2 border">Total Gold (g)</th>
            <th className="px-4 py-2 border">Buyout & Gains (Cash)</th>
            <th className="px-4 py-2 border">Entrepreneur Paid</th>
            <th className="px-4 py-2 border">Inv. Expenses</th>
            <th className="px-4 py-2 border">Ent. Expenses</th>
            <th className="px-4 py-2 border">Investor Exit</th>
            <th className="px-4 py-2 border">Entrepreneur Exit</th>
          </tr>
        </thead>
        <tbody>
          {yearlyData.map((row, index) => (
            <tr key={index} className="text-gray-700 border-t text-center">
              <td className="px-2 py-2">{row.year}</td>
              <td className="px-2 py-2">{formatCurrency(row.assetValue)}</td>
              <td className="px-2 py-2">{formatCurrency(row.investorEquity)}</td>
              <td className="px-2 py-2">{formatCurrency(row.entrepreneurEquity)}</td>
              <td className="px-2 py-2">{formatCurrency(row.rentIncome)}</td>
              <td className="px-2 py-2">{formatCurrency(row.investorNet)}</td>
              <td className="px-2 py-2">{formatCurrency(row.equityBuyout)}</td>
              <td className="px-2 py-2">{formatCurrency(row.reinvestedCapital)}</td>
              <td className="px-2 py-2">{formatCurrency(row.goldExitValue)}</td>
              <td className="px-2 py-2">{row.totalGoldGrams} g</td>
              <td className="px-2 py-2">{formatCurrency(row.nonReinvestedCash)}</td>
              <td className="px-2 py-2">{formatCurrency(row.entrepreneurPaid)}</td>
              <td className="px-2 py-2">{formatCurrency(row.investorTax + row.investorInsurance + row.investorMaintenance)}</td>
              <td className="px-2 py-2">{formatCurrency(row.entrepreneurTax + row.entrepreneurInsurance + row.entrepreneurMaintenance)}</td>
              <td className="px-2 py-2">{formatCurrency(row.investorExitValue)}</td>
              <td className="px-2 py-2">{formatCurrency(row.entrepreneurExitValue)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RentToOwnBusinessYearlyTable;
